import { ISortParams } from "../../components/portfolio/interfaces";
import { DEFAULT_SORT_FIELD } from "../../components/profile/affiliates/contants";
import { apiSlice } from "./apiSlice";

const SORT_PARAMS_MAP: { [key: string]: string } = {
  invitedUser: "[owner]",
  registrationDate: "registrationDate",
  endDate: "endDate",
  leadStatus: "leadStatus",
  earned: "earned",
  pending: "pending",
};

export function buildSortParams(
  params: URLSearchParams,
  sortParams: ISortParams
) {
  let field = SORT_PARAMS_MAP[sortParams.field];
  if (!field) {
    field = SORT_PARAMS_MAP[DEFAULT_SORT_FIELD];
  }
  params.set("sort", `${field}:${sortParams.direction}`);
}

export interface IDateRange {
  start: any;
  end: any;
}
export interface IGetAffiliateProfileParams {
  leadStatus: string;
  userId: string;
  sort: ISortParams;
  dateRange: IDateRange;
}

export interface IGetAffiliatesProfileParamsWithLang {
  params: IGetAffiliateProfileParams;
  lang: string;
}

export function buildUserIdParam(params: URLSearchParams, userId: string) {
  const user = localStorage.getItem("user") || sessionStorage.getItem("user");
  if (user) {
    params.set("filters[owner][id]", JSON.parse(user).id);
    // params.set("filters[owner][id]", "1");
  } else {
    return;
  }
}

export function buildLeadStatusParams(
  params: URLSearchParams,
  leadStatus: string
) {
  if (leadStatus === "all") {
    return;
  }
  params.set("filters[leadStatus]", leadStatus);
}

export function buildDateRangeParam(
  params: URLSearchParams,
  dateRange: IDateRange
) {
  params.set("filters[registrationDate][$gte]", dateRange.start);
  params.set("filters[registrationDate][$lte]", dateRange.end);
}

function CreateGetAffiliatesProfileURLQuery(params: any): string {
  const urlParams = new URLSearchParams();
  urlParams.append("locale", params.lang);

  buildLeadStatusParams(urlParams, params.params.leadStatus);
  buildUserIdParam(urlParams, params.params.userId);
  buildDateRangeParam(urlParams, params.params.dateRange);
  buildSortParams(urlParams, params.params.sort);

  return `/affiliates?${urlParams.toString()}&populate=*`;
}

export const profileAffiliatesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAffiliatesProfile: builder.query({
      query: (params: IGetAffiliatesProfileParamsWithLang) => {
        const url = CreateGetAffiliatesProfileURLQuery(params);
        return {
          url,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useGetAffiliatesProfileQuery } = profileAffiliatesApiSlice;
